/**************************************************
 * Nombre:       Seccion_Detalle_Coleccion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Lista_Productos from "./Componentes/Lista_Productos";
import Home_Categorias from "./Componentes/Home_Categorias";
import Detalle_Categoria_Titulo from "./Componentes/Detalle_Categoria_Titulo";
import {useParams} from "react-router";
import {useEffect, useState} from "react";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {where} from "firebase/firestore";
import {SECCIONES} from "../../Constantes";
import {irArriba} from "../../Utilidades/irArriba";
import Home_Suscripcion from "./Componentes/Home_Suscripcion";

const Seccion_Detalle_Categoria = () => {
    const parms = useParams()
    const [productos, setProductos] = useState([])
    const [nombre, setNombre] = useState('')

    const capitalizarPrimeraLetra = (texto) => {
        if (!texto) return '';
        texto = texto.toLowerCase();
        return texto.charAt(0).toUpperCase() + texto.slice(1);
    }

    useEffect(() => {

        irArriba()

        if (parms && parms.id) {

            setNombre(parms.id)
            setProductos([])
            let cate = capitalizarPrimeraLetra(parms.id)
            let w = [where('categoria', '==', cate), where('estado', '==', 'Publicado')]
            obtenerColWheres({col: 'productos', wheres: w}).then((dox) => {
                if (dox.res) {
                    setProductos(dox.data)
                }
            })

        }

    }, [parms]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Detalle_Categoria_Titulo nombre={nombre}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 0}}>
                <Lista_Productos productos={productos}/>
            </Grid>

            <Grid id={SECCIONES[0]} container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 16, mb: 16}}>
                <Home_Categorias/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mb: 12}}>
                <Home_Suscripcion/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Detalle_Categoria